// extracted by mini-css-extract-plugin
export default {"root":"SingleSignOnDomain_root__blNvS","card":"SingleSignOnDomain_card__dx7zx","content":"SingleSignOnDomain_content__XVmCA","logo":"SingleSignOnDomain_logo__savaO"};